export enum MeetingType {
  InPersonMeeting = 1,
  Virtual = 2,
  Meeting = 3,
  PhoneCall = 4,
}
